<template>
  <div>
    <v-dialog v-model="dialog" persistent eager scrollable max-width="900px">
      <v-form ref="AccomplishmentFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span
              >{{ action }} OPCR
              {{ tab == 1 ? "Core Function" : "Strategic Priority" }}
              Accomplishment</span
            >
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <!-- <v-col cols="12">
                  <v-textarea
                    v-model="description"
                    dense
                    outlined
                    :rules="[formRules.required]"
                    :disabled="tab == 2 && getAccomplishmentLimit == 0"
                    label="Description"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col> -->
                <v-col cols="12">
                  <div v-if="tab == 2" class="text-caption mb-1">
                    <!-- <i
                      >Total Added Accomplishments:
                      {{ getAccomplishmentInFraction }}</i
                    > -->
                  </div>
                  <v-text-field
                    v-model="accomplishment"
                    dense
                    type="number"
                    outlined
                    :rules="
                      tab == 1
                        ? [formRules.numberRequired]
                        : [
                            formRules.numberRequired,
                            // (v) =>
                            //   parseInt(v) <= parseInt(getAccomplishmentLimit) ||
                            //   v == '' ||
                            //   'Value should not exceed the total tagged target/s!',
                          ]
                    "
                    label="Accomplishment Achieved (Numerical Value Only)"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-2">
                  <div class="my-1">
                    <i class="text-caption blue--text"
                      >Note: Change the Actual Accomplishment if needed.</i
                    >
                  </div>
                  <v-textarea
                    color="#6DB249"
                    v-model="getActualAccomplishmentStr"
                    :rules="[formRules.required]"
                    dense
                    outlined
                    label="Actual Accomplishment"
                    class="rounded-lg"
                  >
                  </v-textarea>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    outlined
                    :disabled="data && !data.QL_is_rated"
                    label="Quality"
                    dense
                    :rules="
                      data && data.QL_is_rated
                        ? [
                            formRules.numberNotAboveFiveOrBelowZero,
                            formRules.onlyNumberNoNegative,
                          ]
                        : []
                    "
                    type="number"
                    v-model="Q_rate"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    outlined
                    :disabled="data && !data.timeliness_is_rated"
                    label="Timeliness"
                    dense
                    :rules="
                      data && data.timeliness_is_rated
                        ? [
                            formRules.numberNotAboveFiveOrBelowZero,
                            formRules.onlyNumberNoNegative,
                          ]
                        : []
                    "
                    type="number"
                    v-model="T_rate"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="remarks"
                    :rules="[formRules.required]"
                    dense
                    color="#6DB249"
                    outlined
                    label="Remarks"
                    class="rounded-lg"
                  >
                  </v-textarea>
                </v-col>

                <v-col
                  :cols="showFileInput && !isReuploadFile ? '12' : '9'"
                  v-if="showFileInput"
                >
                  <v-file-input
                    color="#6DB249"
                    outlined
                    accept="application/pdf"
                    v-model="attachedFile"
                    label="File Attachment"
                    dense
                  ></v-file-input>
                </v-col>

                <v-col
                  :cols="isReuploadFile ? '12' : '9'"
                  v-if="action == 'Update' && !isReuploadFile"
                >
                  <v-btn
                    style="color: white"
                    block
                    color="green"
                    @click="ViewFileAttached()"
                    >View Atached File</v-btn
                  >
                </v-col>
                <!-- <v-col
                  cols="2"
                  v-if="action == 'Update' && attachedFile != null"
                >
                  <v-btn color="red" outlined @click="deleteAttachedFile()"
                    ><v-icon>mdi-delete</v-icon> Delete</v-btn
                  >
                </v-col> -->
                <v-col cols="3" v-if="action == 'Update'">
                  <v-btn
                    :color="showFileInput ? 'red' : 'blue'"
                    outlined
                    @click="
                      showFileInput ? cancelUpdate() : updateFileAttached()
                    "
                  >
                    {{
                      showFileInput ? "Cancel File Upload" : "Upload New File"
                    }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>

            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>

            <v-btn
              color="#519043"
              class="white--text"
              v-if="action == 'Add'"
              :disabled="tab == 2 && getAccomplishmentLimit == 0"
              @click="addnew()"
            >
              <v-icon>mdi-check-circle</v-icon>
              SAve
            </v-btn>
            <v-btn
              color="#519043"
              class="white--text"
              v-if="action == 'Update'"
              @click="update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Saves
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- CONFIRM DELETE DIALOG -->
    <v-dialog v-model="confirmDeleteDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-overline mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to remove this and proceed?
            </p>
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="confirmDeleteDialog = false">
            Close
          </v-btn>
          <v-btn color="green" class="white--text" @click="proceedDelete()">
            YES
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ViewOPCRAccomplishmentFiles :data="fileToView" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    action: null,
    tab: null,
    myTaggingType: null,
  },
  components: {
    ViewOPCRAccomplishmentFiles: () =>
      import("../../Views/ViewOPCRAccomplishmentFiles.vue"),
  },

  data() {
    return {
      id: null,
      fileToView: null,
      attachedFile: null,
      dialog: false,
      oldAttachedFile: null,
      description: null,
      targetType: null,
      targetID: null,
      confirmDeleteDialog: false,
      accomplishment: null,
      totalAccomplishment: null,
      T_rate: null,
      Q_rate: null,
      isReuploadFile: false,
      remarks: null,
      actual_accomplishment: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      assessed_by_user: null,
      final_rating_by_user: null,
      actual_accomplishment_to_save: null,
    };
  },
  watch: {
    data: {
      handler(data) {
        console.log("DATA RATE asdasd", data, this.myTaggingType);
        this.dialog = true;
        // if (action == 'Add') {
        this.targetID = data.targetID;
        this.description = data.description;
        this.accomplishment = data.accomplishment;
        this.Q_rate = data.Q_rating;
        this.T_rate = data.T_rating;
        this.remarks = data.remarks;
        this.isReuploadFile = false;
        if (this.action == "Update") {
          this.oldAttachedFile = null;
          this.attachedFile = data.attachment;
        } else {
          this.oldAttachedFile = null;
          this.attachedFile = null;
        }
        // this.actual_accomplishment = data.actual_accomplishment ? data.actual_accomplishment : data.success_indicator;
        // } else {
        //   this.id = null;
        //   this.description = null;
        //   this.accomplishment = null;
        // }

        console.log("TAB", this.tab, data);
        // if (this.tab == 2) {
        //   this.getOPCRTotalAccomplishmentBy(
        //     // data.opcrID,
        //     this.tab,
        //     data.targetID
        //   );
        // }
        // this.year = null;
        // }
      },

      deep: true,
    },
  },

  computed: {
    getAccomplishmentInFraction() {
      let frac;
      if (this.data) {
        if (this.totalAccomplishment) {
          frac = this.totalAccomplishment + " of " + this.data.taggedTarget;
        } else {
          frac = "0 of " + this.data.taggedTarget;
        }
      }

      return frac;
    },

    getAccomplishmentLimit() {
      let limit = 0;
      if (this.data) {
        if (!this.totalAccomplishment) {
          limit = this.data.taggedTarget;
        } else {
          limit = this.data.taggedTarget - this.totalAccomplishment;
        }
      }
      return limit;
    },
    getActualAccomplishmentStr: {
      get() {
        let str = this.data ? this.data.success_indicator : "";
        if (this.data) {
          if (this.tab == 1) {
            str =
              this.accomplishment +
              "/" +
              this.data.efficiency +
              " or (" +
              (
                (this.accomplishment / parseInt(this.data.efficiency)) *
                100
              ).toFixed() +
              "%) " +
              this.data.success_indicator;
          } else {
            str =
              this.accomplishment +
              "/" +
              this.data.taggedTarget +
              " or (" +
              (
                (this.accomplishment / parseInt(this.data.taggedTarget)) *
                100
              ).toFixed() +
              "%) " +
              this.data.success_indicator;
          }
        }

        return str;
      },
      set(val) {
        this.actual_accomplishment_to_save = val;
      },
    },

    showFileInput() {
      let show = true;
      if (this.action == "Add") {
        show = true;
      } else if (this.action == "Update") {
        if (this.isReuploadFile) {
          show = true;
        } else {
          show = false;
        }
      }
      return show;
    },
  },

  methods: {
    initialize() {},

    closeD() {
      this.eventHub.$emit("closeAddAccomplishmentDialog", false);
      this.attachedFile = null;
      this.oldAttachedFile = null;
      this.dialog = false;
    },

    addnew() {
      if (this.$refs.AccomplishmentFormref.validate()) {
        if (this.attachedFile == null) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message =
            "Please upload file attachment to add your accomplishment!";
        }
        let file =
          this.attachedFile.name.split(".")[
            this.attachedFile.name.split(".").length - 1
          ];
        const fd = new FormData();

        if (file !== "pdf") {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Please upload file in pdf format!";
        } else {
          fd.append("file", this.attachedFile);
          let data = {
            opcrID: this.data.opcrID,
            targetType: this.data.targetType,
            targetID: this.data.targetID,
            saveToOpcrPapTargetDistributedTagging:
              this.myTaggingType.type != "vp",
            accomplishment: this.accomplishment,
            description: "",
            actual_accomplishment: this.actual_accomplishment_to_save
              ? this.actual_accomplishment_to_save
              : this.getActualAccomplishmentStr,
            Q_rate: this.Q_rate,
            T_rate: this.T_rate,
            remarks: this.remarks,
            taggingType: this.myTaggingType.type,
          };
          console.log("FORM DATA", data);

          fd.append("body", JSON.stringify(data));
          // console.log(fd);

          this.axiosCall("/opcr-target/addAccomplishment", "POST", fd).then(
            (res) => {
              if (res.data.status == 201) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
                this.closeD();
              } else {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
              }
            }
          );
        }
      }
    },
    deleteAttachedFile() {
      this.confirmDeleteDialog = true;
    },
    proceedDelete() {
      console.log(this.data);
      this.axiosCall(
        "/opcr-target/opcr-accomplishment/" +
          this.attachedFile +
          "/" +
          this.data.id,
        "DELETE"
      ).then((res) => {
        if (res.data.status == 200) {
          this.confirmDeleteDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.attachedFile = null;
          this.action = "Add";
          this.initialize();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },

    ViewFileAttached() {
      if (this.oldAttachedFile != null) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message =
          "Please update first before viewing the new file attached";
      } else {
        let url =
          process.env.VUE_APP_SERVER +
          "/opcr-target/view/opcr-accomplishment/" +
          this.attachedFile;

        let token = localStorage.getItem("token");
        const tab = window.open("about:blank");
        this.isLoading = true;
        fetch(url, { headers: { Authorization: `Bearer ${token}` } })
          .then((response) => response.blob())
          .then((blob) => {
            var _url = window.URL.createObjectURL(blob);

            tab.location = _url;
            tab.focus();
            this.isLoading = false;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    updateFileAttached() {
      this.isReuploadFile = true;
      this.oldAttachedFile = this.attachedFile;
      this.attachedFile = null;
    },

    cancelUpdate() {
      this.isReuploadFile = false;
      this.attachedFile = this.oldAttachedFile;
      this.oldAttachedFile = null;
    },

    update() {
      if (this.$refs.AccomplishmentFormref.validate()) {
        console.log(this.attachedFile);
        console.log(this.oldAttachedFile);

        if (this.showFileInput) {
          if (this.attachedFile == null) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message =
              "Please select a new attachement file before update!";
            return;
          }
          let data = {
            accomplishment: this.accomplishment,
            description: "",
            attachment: this.oldAttachedFile,
            actual_accomplishment: this.actual_accomplishment_to_save
              ? this.actual_accomplishment_to_save
              : this.getActualAccomplishmentStr,
            Q_rate: this.Q_rate,
            T_rate: this.T_rate,
            remarks: this.remarks,
            tab: this.tab,
            saveToOpcrPapTargetDistributedTagging:
              this.myTaggingType.type != "vp",
          };
          console.log("UPDATE DATA", data);

          let file =
            this.attachedFile.name.split(".")[
              this.attachedFile.name.split(".").length - 1
            ];
          const fd = new FormData();
          if (file !== "pdf") {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = "Please upload file in pdf format!";
          } else {
            fd.append("file", this.attachedFile);
            fd.append("body", JSON.stringify(data));
            this.axiosCall(
              "/opcr-target/updateAccomplishmentFileAttached/" +
                this.data.accomplishment_id,
              "PATCH",
              fd
            ).then((res) => {
              if (res.data.status == 200) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
                this.closeD();
              } else {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
              }
            });
          }
        } else {
          let data = {
            accomplishment: this.accomplishment,
            description: "",
            actual_accomplishment: this.actual_accomplishment_to_save
              ? this.actual_accomplishment_to_save
              : this.getActualAccomplishmentStr,
            Q_rate: this.Q_rate,
            T_rate: this.T_rate,
            remarks: this.remarks,
            tab: this.tab,
            saveToOpcrPapTargetDistributedTagging:
              this.myTaggingType.type != "vp",
          };

          console.log("UPDATE DATA", data);
          this.axiosCall(
            "/opcr-target/updateAccomplishment/" + this.data.accomplishment_id,
            "PATCH",
            data
          ).then((res) => {
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          });
        }
      }
    },

    getOPCRTotalAccomplishmentBy(tab, targetID) {
      console.log("CALLED");
      // if (id) {
      this.axiosCall(
        "/opcr-target/getOPCRTotalAccomplishmentBy/" +
          // opcrID +
          // "/" +
          tab +
          "/" +
          targetID,
        "GET"
      ).then((res) => {
        console.log("opcr accompls", res.data);
        if (res.data) {
          console.log("opcr accompls", res.data);
          this.totalAccomplishment = res.data;
          // this.remarksData = res.data;
        }
      });
      // }
    },
  },
};
</script>
